import Vue from 'vue'

import Util from '@/common/Util';
import Task from '@/common/Task';
import * as DateTime from '@/common/DateTime';
import Cytoscape from '@/common/Cytoscape';
import store from '@/store/Store';

let CY = {};
export function initCytoscape(){
  return new Promise( (resolve, reject) =>{
    // let CY = new Cytoscape(); //a common reference to the cytoscape instance
    CY = new Cytoscape(); //a common reference to the cytoscape instance, need to delay until the components have loaded...

    // store.commit('upgradeTasks'); //at load, store doesn't restore the tasks as Task objects..
    store.dispatch('upgradeTasks')
      .then( ()=>{
        store.commit('renumberTasks');
        resolve();
      })
      .catch( (err)=>{
        Vue.$log.info('initCytoscape.upgradeTasks had error:', err );
        reject();
      });
  });
}

export function getTask(thing) {
  // console.log('getTask with thing', thing );
  if (thing == undefined){
    return false;
  }
  if (thing instanceof Task){ //instanceof fails on Task/etc b/c Task doesn't have a .prototype. constructor... or it could be that the store doesn't re-store Objects, just their values...
    // console.log('thing is already a task, returning', thing);
    return thing;
  }
  if (thing.uuid != undefined){
    // console.log('thing.uuid exists');
    thing = thing.uuid;
  }

  for (let t of store.getters.getTasks){
    // console.log('getTask from thing[' + thing + ']: != ['+ t.toString()+']');
    if ( t.uuid == thing ) {
      // console.log(t.uuid + ' == ' + thing );
      return t;
    }
    if ( t.num == thing ){
      // console.log(t.num + ' == ' + thing );
      return t;
    }
    if ( t.name == thing ) {
      // console.log(t.name + ' == ' + thing );
      return t;
    }
  }
  return false;
  //store tasks may not be Tasks, so detect and upgrade if needed
}//getTask

export function addTask(name, dateDue, hoursPlanned) {
  // Vue.$log.debug('addTask');

  // renumberTasks();

  let gname = getTask( name );
  if (gname != false){
    let msg = 'Task [' + gname +'] is already present';
    Vue.$log.info( msg );
    return Util.retobj( false, msg );

  }else {
    if (isNaN(hoursPlanned)) {
      hoursPlanned = 0;
      Vue.$log.debug('addTask: setting blank hoursPlanned to 0');
    }

    let newt = new Task(name, dateDue, hoursPlanned);
    console.log('adding new task newt', newt);
    store.commit('addTask', newt );
    return Util.retobj( true, 'added task' );
  }
}

export function delTask( thing ){
  let task = getTask( thing );
  if (task != false){
    store.commit('delTask', task.uuid); //store manages edge translation
    return Util.retobj( true, 'deleted task' );
  }
  return Util.retobj( false, 'Task' + thing + ' not found, not deleted' );
}

export function puntTask( thing ){ //move dateDue to today+ 1 month
  let task = getTask( thing );
  if (task != false){
    store.commit('puntTask', task.uuid); //store manages edge translation
    return Util.retobj( true, 'punted task' );
  }
  return Util.retobj( false, 'Task' + thing + ' not found, not punted' );
}


export function addEdge( thingP, thingC ){
  // Vue.$log.debug('addEdge');

  // console.log('thingp', thingP);
  let tp = getTask( thingP );
  let tc = getTask( thingC );
  let ed = {uuid: Util.uuidv4(), source: tp.uuid, target: tc.uuid};
  // console.log('addEdge', ed);

  //does edge exist?
  if (!getEdge( ed.source, ed.target )){
    store.commit('addEdge', ed);
    // console.log('edge added: ' + tp.name + ' -- ' + tc.name);
    return true;
  } else {
    console.log('edge exists: ' + tp.name + ' -- ' + tc.name);
    return false;
  }
}

export function delEdge( thingP, thingC){
  let tp = getTask( thingP );
  let tc = getTask( thingC );
  let ed = getEdge(tp.uuid, tc.uuid);
  // console.log('delEdge found [' + tp.uuid + '--'+tc.uuid+']', ed);
  store.commit('delEdge', ed.uuid );
}

export function getEdge( source, target ){
  for (let ed of store.getters.getEdges ){
    if( source == ed.source  && target == ed.target ){
      // console.log('getEdge found', ed);
      return ed;
    }
  }
  return false;
}

export function drawGraph( ) {
  Vue.$log.info('Graph.drawGraph');
  //get tasks and edges from the store, compute node and edge styles, call CY.drawGraph()
  let tasks = store.getters.getTasks;
  let nodes = []; //
  for (let t of tasks){
    nodes.push( makeTaskNodeForGraph( t ) );
  }
  // console.log('tasks from store', tasks);
  // console.log('made nodes', nodes);

  let storeEdges = store.getters.getEdges;
  let edges = [];
  for (let ed of storeEdges){
    // edges.push( {id: ed.uuid, source:ed.source, target:ed.target} );

    //calculate weight: get number of connections for each node
    let ns = 0;
    let nt = 0;
    for (let e of storeEdges){
      ns = ns + (ed.source == e.target) + (ed.source == e.source); //#edges of the source node
      nt = nt + (ed.target == e.target) + (ed.target == e.source); //#edges of the target node
    }
    // Vue.$log.info('edgeWeight = ' + ns + ' + ' + nt + ' = ' + (ns+nt) + ' == ' + (1/(1+ns+nt)));
    // edges.push( {id: ed.uuid, source:ed.source, target:ed.target, weight: ns+nt} );
    edges.push( {id: ed.uuid, source:ed.source, target:ed.target, weight: ns+nt} );
  }
  // console.log('edges from store', edges);

  CY.drawGraph( nodes, edges );
}

function makeTaskNodeForGraph( task ){ //creates a task structure and adds the styling
  // console.log('have task', task);
  let node = {
    id: task.uuid,
    name: task.num + ': ' + task.name + ': ' + task.pctDone + '%',
    // style: {
    //   fill: 'white'
    // }
    // style: task.getTaskStyle()
    style: getTaskStyle(task)
  };
  return node;
}

function getTaskStyle(task){
  //due date is approaching
  let today = DateTime.getNow();
  let borderStyle = '';
  let fillStyle = '';
  let textStyle = '';

  let red = 'rgb(255,0,0)';
  let org = 'rgb(255,127,0)';
  let ylw = 'rgb(255,220,0)';
  let grn = 'rgb(000,150,000)';
  let cyn = 'rgb(120,255,140)';
  let gry100 = 'rgb(100,100,100)';
  let gry150 = 'rgb(150,150,150)';
  let wht = 'rgb(255,255,255)';
  let blk = 'rgb(0,0,0)';
  let blu = 'rgb(0,0,255)';

  // console.log(task.name + ' = ' + task.dateDue.diffHours(today) );
  let diff = DateTime.diffHours( task.dateDue, today );
  if (diff < 0){ //red background and border
    textStyle = blk;
    borderStyle = red;
    fillStyle = red;
  } else if (diff < 72){ //red border
    textStyle = blk;
    borderStyle = red;
    fillStyle = wht;
  } else if (diff < 120){ //orange border
    textStyle = blk;
    borderStyle = org;
    fillStyle = wht;
  } else if (diff < 240){ //yellow border
    textStyle = blk;
    borderStyle = ylw;
    fillStyle = wht;
  } else if (diff < 336){ //green border
    textStyle = blk;
    borderStyle = grn;
    fillStyle = wht;
  } else{ // no border
    textStyle = blk;
    borderStyle = blu;
    fillStyle = wht;
  }

  //if done override preceeding
  if (100 <= task.pctDone){
    textStyle = gry100;
    borderStyle = gry100;
    fillStyle = gry150;
  }
  let style = { stroke: borderStyle, text: textStyle, fill: fillStyle };
  // console.log('computed task style', style);
  return style;
}

export function printTasks() {
  // let dfs = CY.getDFS();

  let tasks = store.getters.getTasks;
  let edges = store.getters.getEdges;
  let toprint = '';
  for (let t of tasks){
    // toprint = toprint + t.num + ': ' + t.name + ' -- ' + + ' = ' + t.pctDone + '%\n';
    if ( !(t instanceof Task) ){
      console.log('task is not Task', t);
    }
    toprint = toprint + t.toString() + '\n';
  }
  Vue.$log.info('printTasks:\n' + toprint, {tasks: tasks, edges:edges});
  return toprint;
} //print tasks

export function clearGraph(){
  store.commit('clearStore');
  CY.clearGraph();
}

export function loadJSON(){
  Vue.$log.info('Graph.loadJSON');
  openFile().then( (gfile) => {
    // console.log('opened gfile', gfile);
    let gjson = JSON.parse( gfile );
    console.log('opened gjson', gjson);
    // CY.setGraphFromJSON( gjson );

    if (gjson.meta.windowTitle != undefined){
      store.commit('setWindowTitle', gjson.meta.windowTitle);
      Vue.$log.info('setWindowTitle from gjson', store.getters.getWindowTitle );
    }

    for (let t of gjson.tasks){
      store.commit('addTask', t);
    }
    for (let e of gjson.edges){
      store.commit('addEdge', e);
    }

    for (let t of gjson.tasks){ //add in edges listed as parentus / childus
      if (t.parentus.length > 0){
        for (let pu of t.parentus){
          addEdge( pu, t.uuid );
        }
      }
      if (t.childus.length > 0){
        for (let cu of t.childus){
          addEdge( t.uuid, cu );
        }
      }
    }
    drawGraph();
  })
  .catch( (err)=>{
    console.log('loadJSON caught error', err);
  });
}

function openFile(){
  return new Promise( (resolve,reject) => {
    if (window.File) { // Check for the various File API support
      let filejson = ''; //loaded file

      let infile = document.createElement('input'); // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file
      infile.type = 'file';
      infile.accept = 'text/json';
      infile.addEventListener('input', (val)=>{
        // console.log('input fired, val =', val);
        // console.log('input fired, infile', infile);
        let fileread = new FileReader();
        fileread.addEventListener('loadend', (val)=>{
          // console.log('loaded file', fileread);
          filejson = fileread.result;
          // console.log('filejson', filejson);

          resolve(filejson);
        });

        fileread.readAsText( infile.files[0] );
      });

      document.body.appendChild(infile);
      infile.click();
      setTimeout( ()=>{
        document.body.removeChild(infile);
      }, 1);

      // infile.addEventListener('change'

    } else {
      alert('The File APIs are not fully supported in this browser, cannot load graph.');
      reject(false);
    }
    // reject(false);
  });
}

export function saveJSON(){ //save the graph json
  // let gjson = CY.getGraphJSON(); //save the Cytoscape data...is this actually needed?

  //save the store data, all else is downstream
  // there should be a way to get this json from vuex-persist and have it restore everything, a user-in-the-loop json-based restore function...
  let gjson = {
    tasks: store.getters.getTasks,
    edges: store.getters.getEdges,
    meta: {
      dateSaved: new Date().toString(),
      windowTitle: store.getters.getWindowTitle
    }
  }

  // console.log('gjson', gjson);
  // saveFile( gjson, 'Tasker.json', 'text/json' );
  saveFile( gjson, store.getters.getWindowTitle+'.json', 'text/json' );
}

function saveFile(data, filename, ftype) {
  if (window.File) { // Check for the various File API support.
    let file = new File([JSON.stringify(data, '', 2)], filename, {type:ftype} );
    // console.log('file',file);

    let url = URL.createObjectURL(file);
    let a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout( ()=>{
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 1);

  } else {
    alert('The File APIs are not fully supported in this browser, cannot save graph.');
  }
}


